<template>
    <figure>
        <img 
            @click="expandSidebar"
            src="@/assets/images/punto_red_icon_new.png" 
            alt="punto red logo">
    </figure>
</template>
<script>
    import { mapActions } from "vuex";

    export default {
        name: "BannerLite",
        methods: {
            expandSidebar(){
                this.showSidebar()
            },
            ...mapActions("interface", {
                hideSidebar: "hideSidebar",
                showSidebar: "showSidebar"
            })
        }
    }
</script>
<style lang="scss" scoped>
    img {
        height: 47px;
    }
</style>

